<template>
  <v-layout row wrap>
    <v-flex xs12 md8 order-xs2 order-md1>
      <v-card color="white" class="rounded">
        <!-- <v-card-title class="mb-0">
          <h4 class="subheading ml-1">Edit Profile</h4>
        </v-card-title> -->
        <v-card-text>
          <v-form
            v-model="FormValid"
            v-on:submit.prevent="postProfile"
            ref="form"
          >
            <v-text-field
              v-model="localUserSelfProfile.firstname"
              @input="localDebounce"
              label="First Name"
              :rules="nameRules"
            ></v-text-field>
            <v-text-field
              v-model="localUserSelfProfile.lastname"
              @input="localDebounce"
              label="Last Name"
              :rules="nameRules"
            ></v-text-field>
            <v-text-field
              v-model="localUserSelfProfile.phonenumber"
              @input="localDebounce"
              label="Phone Number"
              :rules="phoneRules"
            ></v-text-field>
            <v-select
              v-model="localUserSelfProfile.country"
              :items="countryList"
              item-text="text"
              item-value="value"
              label="Country"
              placeholder="Country"
              :rules="requiredRules"
            ></v-select>
            <v-text-field
              class="mb-2"
              v-model="localUserSelfProfile.dateofbirth"
              @input="localDebounce"
              label="Date of Birth"
              hint="Enter date in MM/DD format without YEAR"
              :rules="requiredRules"
              :disabled="!localUserSelf.canUpdateBirthDate"
            ></v-text-field>
            <v-text-field
              class="mb-2"
              v-model="localUserSelfProfile.startdate"
              @input="localDebounce"
              label="Start Date"
              hint="Enter date in MM/DD/YYYY format"
              :disabled="!localUserSelf.canUpdateStartDate"
            ></v-text-field>
            <v-text-field
              v-model="localUserSelfProfile.email"
              @input="localDebounce"
              label="Email Address"
              readonly
              disabled
            ></v-text-field>
            <v-checkbox v-model="acceptTerms" color="#d13b55">
              <template v-slot:label>
                <div>
                  I agree and accept Ovation
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="https://ovation-uploads.s3.us-east-2.amazonaws.com/common/Ovation-Terms-of-Service.pdf"
                        @click.stop
                        v-on="on"
                      >
                        Terms and Conditions
                      </a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>
            <v-btn
              class="btn-rounded-medium white--text"
              v-if="showSaveButton"
              color="#d13b55"
              @click.prevent="postProfile"
              :disabled="!FormValid || !acceptTerms"
            >
              Save
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex order-md2></v-flex>
    <v-flex xs12 md3 px-3 pb-3 class="text-xs-center" order-xs1 order-md3>
      <v-card color="white" class="rounded">
        <v-card-text>
          <div>
            <v-avatar color="primary" size="120">
              <img
                v-if="$store.getters.isProfileImageSet"
                :src="$store.getters.getProfileImageUrl"
                :alt="$store.getters.getUserFullName"
                :title="$store.getters.getUserFullName"
              />
              <span v-else class="white--text display-3">{{
                this.$store.getters.getUserInitials
              }}</span>
            </v-avatar>
          </div>
          <div class="ma-4">
            <div class="title mb-2">
              {{ this.$store.getters.getUserFullName }}
            </div>
            <v-flex>
              <v-form
                v-model="inviteFormValid"
                v-on:submit.prevent="onUploadSelectedFile"
                ref="inviteFileForm"
              >
                <v-progress-linear
                  :indeterminate="true"
                  height="3"
                  v-if="isImageUploading"
                ></v-progress-linear>
                <div v-if="!isImageUploading">
                  <v-icon color="blue darken-2" size="18px"
                    >mdi-cloud-upload</v-icon
                  >
                  <a
                    class="px-1"
                    href="#"
                    v-if="!isImageUploading"
                    title="Click here to change profile picture..."
                    @click.prevent="onPickInviteFile"
                    >Change Profile Picture</a
                  >
                </div>

                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="inviteFileInput"
                  accept="image/*"
                  @change="onInviteFilePicked"
                />
              </v-form>
            </v-flex>
            <!-- <router-link
              to="/changeprofileimage"
              style="text-decoration:none;"
            >Change Profile Picture</router-link>-->
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import debounce from "debounce";
import validationRules from "@/js/validationRules.js";

export default {
  name: "ProfileInfo",
  props: {
    showSaveButton: { type: Boolean, default: true },
  },
  data() {
    return {
      FormValid: true,
      nameRules: validationRules.nameRules,
      phoneRules: validationRules.phoneRules,
      requiredRules: validationRules.requiredRules,
      localUserSelfProfile: null,
      localDebounce: null,
      dateMenu: false,
      maxAllowedDate: new Date().toISOString().substr(0, 10),
      localUserSelf: null,
      acceptTerms: false,
      inviteFormValid: true,
      inviteFileObject: null,
      isImageUploading: false,
      countryList: [
        { text: "Australia", value: "AU" },
        { text: "Canada", value: "CA" },
        { text: "France", value: "FR" },
        { text: "Germany", value: "DE" },
        { text: "India", value: "IN" },
        { text: "Singapore", value: "SG" },
        { text: "United Arab Emirates", value: "AE" },
        { text: "United Kingdom", value: "GB" },
        { text: "United States", value: "US" },
      ],
    };
  },
  computed: {},
  methods: {
    postProfile() {
      // parse/validate dates here
      if (this.localUserSelfProfile.dateofbirth.length > 5) {
        this.$store.commit("replaceSnackbar", {
          message:
            "Invalid Date of Birth, Enter date in MM/DD format without YEAR",
          messageType: "warning",
        });
        return false;
      }
      var bdIsValid = moment(
        this.localUserSelfProfile.dateofbirth,
        ["MM/DD", "M/D"],
        true
      ).isValid();

      if (!bdIsValid) {
        this.$store.commit("replaceSnackbar", {
          message:
            "Invalid Date of Birth, Enter date in MM/DD format without YEAR",
          messageType: "warning",
        });
        return false;
      }

      if (this.localUserSelfProfile.startdate) {
        var sdIsValid = moment(
          this.localUserSelfProfile.startdate,
          ["MM/DD/YYYY", "M/D/YYYY"],
          true
        ).isValid();

        if (!sdIsValid) {
          this.$store.commit("replaceSnackbar", {
            message: "Invalid Start Date, Enter date in MM/DD/YYYY format",
            messageType: "warning",
          });
          return false;
        }
      }

      // Also check if user accepts terms
      if (!this.acceptTerms) {
        this.$store.commit("replaceSnackbar", {
          message:
            "To continue, you must agree and accept Ovation Terms and Conditions",
          messageType: "warning",
        });
        return false;
      }

      // Disable form submission while async call takes place
      this.FormValid = false;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving profile...",
        messageType: "warning",
      });

      axios
        .post(
          "/api/user/self",
          this.localUserSelfProfile,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Allow form submission
          this.FormValid = true;

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);

          // User profile may have be complete - dispatch for potential update to global flag
          this.$store.commit("refreshUserProfileIsComplete");

          this.localUserSelf = JSON.parse(
            JSON.stringify(this.$store.state.userSelf || {})
          );

          this.localUserSelfProfile = JSON.parse(
            JSON.stringify(this.$store.state.userSelf.profile || {})
          );

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Profile Saved.",
          });
        })
        .catch((e) => {
          // Allow form submission
          this.FormValid = true;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message: "Error: Profile was NOT updated. Error #NRI837",
            messageType: "error",
          });
        });
    },
    onPickInviteFile() {
      this.$refs.inviteFileInput.click();
    },
    onInviteFilePicked(event) {
      const files = event.target.files;
      if (files[0] !== undefined) {
        // Check validity of file
        if (files[0].name.lastIndexOf(".") <= 0) {
          this.inviteFormValid = false;
          return;
        }
        const validImageTypes = [
          "image/gif",
          "image/jpeg",
          "image/png",
          "image/jpg",
        ];

        // If valid, continue
        // validate file size and type
        if (
          files[0].size > 4000000 ||
          !validImageTypes.includes(files[0].type)
        ) {
          this.$store.commit("replaceSnackbar", {
            message:
              "File size should be less than 4 MB and should be valid image type",
            messageType: "warning",
          });
          this.inviteFormValid = false;
          return;
        }

        this.inviteFileObject = files[0]; // this is an file that will be send to server...
        this.inviteFormValid = true;
        this.onUploadSelectedFile();
      }
    },
    onUploadSelectedFile() {
      // A file is not chosen!
      if (!this.inviteFileObject || !this.inviteFormValid) {
        this.$store.commit("replaceSnackbar", {
          message: "No profile picture selected.",
          messageType: "warning",
        });
        this.inviteFormValid = false;
        return;
      }

      this.$store.commit("replaceSnackbar", {
        message: "Changing profile picture...",
        messageType: "warning",
      });

      this.isImageUploading = true;

      // get the csv file into a js object
      let formData = new FormData();
      formData.set("isavatarlocal", true);
      formData.append("file", this.inviteFileObject);

      // set the axios config to multipart/form-data without updating the main store version
      let localAxiosConfig = JSON.parse(
        JSON.stringify(this.$store.state.axiosConfig)
      );
      localAxiosConfig.headers["content-type"] = "multipart/form-data";

      axios
        .post("/api/user/profileimage", formData, localAxiosConfig)
        .then((response) => {
          this.isImageUploading = false;

          this.$store.commit("replaceSnackbar", {
            message: "Profile picture has been changed",
            messageType: "success",
          });

          this.$store.state.userSelf.profile.isavatarlocal = true;
          this.$store.state.userSelf.profile.avatarlocal =
            response.data.avatarlocal;
        })
        .catch((e) => {
          this.isImageUploading = false;

          // check/handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Change profile image failed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
  },
  beforeMount() {
    // Get a non-responsive copy for local use of the user profile to be updated
    this.localUserSelf = JSON.parse(
      JSON.stringify(this.$store.state.userSelf || {})
    );
    this.localUserSelfProfile = JSON.parse(
      JSON.stringify(this.$store.state.userSelf.profile || {})
    );
    /* var avatar = this.localUserSelfProfile.avatar;
    this.localUserSelfProfile.avatar = this.localUserSelfProfile.avatarlocal;
    this.localUserSelfProfile.avatarlocal = avatar; */
  },
};
</script>
